import React, { Component } from 'react';
import { Table } from 'react-bootstrap/lib';
import { Radio, Checkbox, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/workingexperiences/reference/"

class WerkervaringReferentieEmail extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.state = {
            references: [],
            data: []
        }
    }

    handleChange(event) {
        const target = event.target
        const id = target.name
        const value = target.value === "agree"
        //const checked = target.checked
        this.setState({ data: { ...this.state.data, [id]: value } })
        Api.print(`${id}: ${value}`)
        Api.print(this.state)
    }
    // Send data
    handleClick(event) {
        var payload = {}
        var data = []
        Api.print(this.state)
        Object.keys(this.state.data).forEach(e => {
            data.push({ id: e, accepted: this.state.data[e] })
        })
        payload.data = data
        Api.PostApi(FETCH_URL + this.props.match.params.ref, payload, this.props.history).then(data => {
            alert("Bedankt voor deze bevestiging.")
        })
    }

    componentDidMount() {
        Api.GetApi(FETCH_URL + this.props.match.params.ref).then(data => {
            let references = data.workingexperiences.map(ref => {
                let id = ref.id
                let detailUrl = `/referenten/detail/${this.props.match.params.ref}/${ref.id}`
                //this.setState({ data: { ...this.state.data, [id]: false } })
                Api.print(`${id}: ${this.state.data[id]}`)
                return <tr key={id}>
                    <td>{ref.member}</td>
                    <td>{ref.company}</td>
                    <td>{ref.level}</td>
                    <td>{ref.customer}</td>
                    <td>{ref.project}</td>
                    <td>{ref.city}</td>
                    <td>{ref.years}</td>
                    <td>{ref.hours}</td>
                    <td><LinkContainer exact to={detailUrl}><Button type="button" className="pull-left">Details</Button></LinkContainer></td>
                    <td><Radio name={id} value="agree" defaultChecked={this.state.data[id]} onChange={this.handleChange}></Radio></td>
                    <td><Radio name={id} value="notAgree" defaultChecked={!this.state.data[id]} onChange={this.handleChange}></Radio></td>
                </tr>
            })

            this.setState({ references: references })
        })
    }

    render() {
        return (
            <div>
                {this.state.references.length !== 0 ?
                    <div>
                        <h3>Geachte heer, mevrouw,</h3>
                        <p>Een of meerdere kandidaat-leden van het Constructeursregister hebben u als referent opgegeven voor het beoordelen van hun werkervaring. Pas na uw akkoordbevinding wordt de werkervaring meegewogen in de toetsing voor registerconstructeur of registerontwerper.</p>
                        <br />
                        <p>Het is van groot belang dat u de beoordeling serieus neemt, omdat de werkervaring een essentieel onderdeel vormt van de toetsing.</p>
                        <br />
                        <p>U dient het volgende te boordelen:</p>
                        <ul>
                            <li>Heeft de aanvrager werkzaamheden uitgevoerd op het opgegeven project.</li>
                            <li>Heeft de aanvrager op het opgegeven niveau gefunctioneerd? Heeft de aanvragen de verantwoordelijkheid gedragen die bij het functieniveau past? Zie onderstaande tabel voor de functieniveaus</li>
                            <li>Klopt het aantal opgegeven uren dat hij aan het project in die functie heeft gewerkt.</li>
                            <li>Zijn de werkzaamheden met voldoende resultaat uitgevoerd.</li>
                        </ul>
                        <br />
                        <p>Bij twijfel geeft u geen akkoord.</p>
                        <br />
                        <p>De toetsingscommissie behoudt zich het recht voor contact met u op te nemen om nadere vragen te stellen over een kandidaat die u als referent heeft opgegeven.</p>
                        <h3>Functieniveaus</h3>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Werkzaamheden</th>
                                    <th>Niveau</th>
                                    <th>Eenheid</th>
                                    <th>n</th>
                                    <th>γ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Tekenaar maakt onder leiding constructieve tekeningen</td>
                                    <td>C1</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>0</td>
                                </tr>
                                <tr>
                                    <td>Constructeur ontwerpt en berekent details en/of bouwdelen onder supervisie</td>
                                    <td>C2</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>0,4</td>
                                </tr>
                                <tr>
                                    <td>Constructeur ontwerpt en berekent zelfstandig details en/of bouwdelen, berekent onder supervisie hoofddraagconstructies</td>
                                    <td>C3</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>0,8</td>
                                </tr>
                                <tr>
                                    <td>Constructeur ontwerpt/berekent zelfstandig constructies</td>
                                    <td>C4</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>1,0</td>
                                </tr>
                                <tr>
                                    <td>Constructeur / projectleider</td>
                                    <td>C5</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>1,2</td>
                                </tr>
                                <tr>
                                    <td>Specialist constructeur</td>
                                    <td>O1</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>0,8</td>
                                </tr>
                                <tr>
                                    <td>Constructief adviseur, raadgevend adviseur</td>
                                    <td>O2</td>
                                    <td>jaren</td>
                                    <td></td>
                                    <td>1,2</td>
                                </tr>
                            </tbody>
                        </Table>


                        <div>
                            <h5>Beordeel referenties</h5>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Aanvrager</th>
                                        <th>Huidige werkgever</th>
                                        <th>Niveau</th>
                                        <th>Uitgevoerd voor</th>
                                        <th>Project</th>
                                        <th>Locatie</th>
                                        <th>Jaar</th>
                                        <th>Uren</th>
                                        <th>Details</th>
                                        <th>Akkoord</th>
                                        <th>Niet akkoord</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.references}
                                </tbody>
                            </Table>
                            <Checkbox> Referent verklaart kennis genomen hebben van de beoordelingscriteria en verklaart de werkervaring naar waarheid beoordeeld te hebben.</Checkbox>
                            <Button type="button" onClick={this.handleClick}>Beoordeling Opslaan</Button>
                        </div>

                    </div> : <div><p style={{ color: 'red' }}>
                        Hartelijk dank voor uw medewerking! De werkervaring is geaccordeerd. U heeft nu geen toegang meer.</p>
                        <br />
                        <p>info@constructeursregister.nl | 088-353 12 99 | Louis Braillelaan 80 | 2719 EK Zoetermeer</p>
                    </div>}
            </div>
        );
    }
}

export default WerkervaringReferentieEmail


// WEBPACK FOOTER //
// ./src/components/Member/Pages/Werkervaring/WerkervaringReferentieEmail.js